import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";

const api = new APIClient();

const RESOURCE = "/units";

export interface Unit {
  id: number;
  tenant_id: number;
  name: string;
  country_code: string;
  phone_number: string;
  street?: string | null;
  street_number?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  knowledge_base?: string | null;
  google_review_url?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateUnitPayload {
  name: string;
  country_code?: string;
  phone_number: string;
  street?: string | null;
  street_number?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  knowledge_base?: string | null;
  google_review_url?: string | null;
}

export type UpdateUnitPayload = Partial<CreateUnitPayload>;

export interface UnitListParams extends PaginationParams {
  search?: string;
}

export const getUnits = (
  params?: UnitListParams
): Promise<PaginatedApiResponse<Unit>> =>
  api.get<PaginatedApiResponse<Unit>>(RESOURCE, params);

export const getUnit = (id: number): Promise<ApiResponse<Unit>> =>
  api.get<ApiResponse<Unit>>(`${RESOURCE}/${id}`);

export const createUnit = (
  payload: CreateUnitPayload
): Promise<ApiResponse<Unit>> =>
  api.create<ApiResponse<Unit>>(RESOURCE, payload);

export const updateUnit = (
  id: number,
  payload: UpdateUnitPayload
): Promise<ApiResponse<Unit>> =>
  api.update<ApiResponse<Unit>>(`${RESOURCE}/${id}`, payload);

export const deleteUnit = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);
